// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bih_h bih_kh bih_we bih_su bih_vt bih_sw bih_sn"};